var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPersonNoInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4287 19C26.3993 19 30.4287 14.9706 30.4287 10C30.4287 5.02944 26.3993 1 21.4287 1C16.4581 1 12.4287 5.02944 12.4287 10C12.4287 14.9706 16.4581 19 21.4287 19Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 23.8C12.7157 23.8 6 30.6053 6 39.0001H36C36 30.6053 29.2843 23.8 21 23.8Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 39C36.4036 39 42 33.4036 42 26.5C42 19.5964 36.4036 14 29.5 14C22.5964 14 17 19.5964 17 26.5C17 33.4036 22.5964 39 29.5 39Z",
    fill: "#FF5959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9752 30.736L32 17H27L27.9938 30.736H30.9752ZM31.8137 37V32.8427H27.1863V37H31.8137Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPersonNoInfo);
export default __webpack_public_path__ + "static/media/ico_person_no_info.1120d4a07db6b274bdd5a1419be32e8a.svg";
export { ForwardRef as ReactComponent };